/*
 * View for report loading progress bar
 */

define(["marionetteBase", "messaging/messenger", "./template/progressBarTemplate.html"], function (
  MarionetteBase,
  Messenger,
  ProgressBarTemplate,
) {
  "use strict";

  // Adjust for the fact that Marionette might have come from node_modules, in which case it includes a "default" value
  // at the top level that is really what we want
  const Marionette = MarionetteBase.default || MarionetteBase.Marionette || MarionetteBase;
  const ProgressBarView = {};

  ProgressBarView.progressBarView = Marionette.ItemView.extend({
    template: ProgressBarTemplate,
    className: "max-height",
    onRender: function () {
      this.$el.i18n();
      Messenger.vent.on(
        "update:progress:bar",
        function (percentComplete) {
          const updatedWidth = 4 * percentComplete;
          this.updateProgressBar(updatedWidth);
        },
        this,
      );
    },
    updateProgressBar: function (updatedWidth) {
      this.$el.find("#reportProgressBar").animate({ width: updatedWidth }, 100);
    },
  });

  return ProgressBarView;
});
